import React from "react";
import { MapPinOff } from "lucide-react";
import { PedidoSemLocalizacao } from "../../../services/roteirizacaoService";

interface PedidosSemLocalizacaoProps {
  items: PedidoSemLocalizacao[];
}

const PedidosSemLocalizacaoList: React.FC<PedidosSemLocalizacaoProps> = ({
  items,
}) => {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-100">
          <MapPinOff size={20} className="text-amber-700" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-neutral-900">
            Sem localização
          </h3>
          <p className="text-sm text-neutral-500">
            Não entram no casamento automático (endereço insuficiente ou falha
            no Google) — use o Roteirista manual
          </p>
        </div>
      </div>

      {items.length === 0 ? (
        <p className="text-sm text-neutral-500">
          Todos os pedidos prontos estão geocodificados.
        </p>
      ) : (
        <ul className="divide-y divide-neutral-100">
          {items.map((item) => (
            <li
              key={item.pedidoIntegracaoId}
              className="flex flex-wrap items-start justify-between gap-2 py-3"
            >
              <div>
                <p className="font-semibold text-neutral-900">
                  #{item.displayId}
                  {item.customerName ? ` · ${item.customerName}` : ""}
                </p>
                {item.enderecoResumo && (
                  <p className="text-xs text-neutral-500">{item.enderecoResumo}</p>
                )}
              </div>
              <span className="rounded bg-amber-50 px-2 py-1 text-xs text-amber-800">
                {item.motivo}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PedidosSemLocalizacaoList;
